!function() {
    "use strict";
    
    const SELECTORS = {
        productForm: ".product-form",
        productOption: ".product-form__option", 
        selectedValue: ".product-form__selected-value"
    };
    
    // Palavras-chave para microfone em português (Brasil)
    const MICROPHONE_KEYWORDS = [
        "mic",           // Abreviação comum
        "micro",         // Abreviação informal
        "microfone",     // Palavra completa
        "microfones",    // Plural
        "microphone",    // Inglês (às vezes usado)
        "micrófono",     // Variação com acento
        "microfono"      // Sem acento
    ];
    
    const Modal = {
        create(content) {
            const existingModal = document.querySelector('.mic-modal');
            if (existingModal) {
                return existingModal;
            }
            
            const modal = document.createElement('div');
            modal.className = 'mic-modal';
            modal.setAttribute('role', 'dialog');
            modal.setAttribute('aria-modal', 'true');
            modal.setAttribute('aria-labelledby', 'modal-title');
            
            modal.innerHTML = `
                <div class="mic-modal__content">
                    <button type="button" class="mic-modal__close" aria-label="Fechar">&times;</button>
                    <div id="modal-title" class="sr-only">Informações sobre opções de microfone</div>
                    <div class="mic-modal__body">${content}</div>
                </div>
            `;
            
            document.body.appendChild(modal);
            this._setupEvents(modal);
            
            // Animação de entrada
            requestAnimationFrame(() => {
                modal.classList.add('mic-modal--visible');
                modal.querySelector('.mic-modal__content').classList.add('mic-modal__content--visible');
            });
            
            return modal;
        },
        
        _setupEvents(modal) {
            // Botão fechar
            modal.querySelector('.mic-modal__close').addEventListener('click', () => {
                this.close(modal);
            });
            
            // Clique fora do modal
            modal.addEventListener('click', (event) => {
                if (event.target === modal) {
                    this.close(modal);
                }
            });
            
            // Tecla ESC
            const escapeHandler = (event) => {
                if (event.key === 'Escape' && document.querySelector('.mic-modal--visible')) {
                    this.close(modal);
                }
            };
            document.addEventListener('keydown', escapeHandler);
            
            // Armazenar referência do handler para remoção posterior
            modal._escapeHandler = escapeHandler;
        },
        
        close(modal) {
            if (!modal) return;
            
            // Remover classes de visibilidade
            modal.querySelector('.mic-modal__content').classList.remove('mic-modal__content--visible');
            modal.classList.remove('mic-modal--visible');
            
            // Remover do DOM após animação
            const transitionHandler = () => {
                if (modal.parentNode) {
                    document.body.removeChild(modal);
                }
                if (modal._escapeHandler) {
                    document.removeEventListener('keydown', modal._escapeHandler);
                }
                modal.removeEventListener('transitionend', transitionHandler);
            };
            
            modal.addEventListener('transitionend', transitionHandler);
        }
    };
    
    const MicrophoneInfo = {
        init() {
            this._addInfoButtons();
            this._setupMutationObserver();
        },
        
        _addInfoButtons() {
            document.querySelectorAll(SELECTORS.productOption).forEach(option => {
                const selectedValue = option.querySelector(SELECTORS.selectedValue);
                if (!selectedValue) return;
                
                const text = selectedValue.textContent.toLowerCase().trim();
                const hasMicrophoneKeyword = this._containsMicrophoneKeyword(text);
                
                // Adicionar botão apenas se contém palavra-chave de microfone e ainda não tem botão
                if (hasMicrophoneKeyword && !option.querySelector('.mic-info-icon')) {
                    this._createInfoButton(option);
                }
            });
        },
        
        _containsMicrophoneKeyword(text) {
            return MICROPHONE_KEYWORDS.some(keyword => {
                return text.includes(keyword.toLowerCase());
            });
        },
        
        _createInfoButton(option) {
            const button = document.createElement('button');
            button.type = 'button';
            button.className = 'mic-info-icon';
            button.innerHTML = '&#9432;'; // ℹ️ símbolo de informação
            button.setAttribute('aria-label', 'Informações sobre opções de microfone');
            
            // Conteúdo do modal
            const modalContent = this._getModalContent();
            
            button.addEventListener('click', () => {
                Modal.create(modalContent);
            });
            
            option.appendChild(button);
        },
        
        _getModalContent() {
            // Verificar se as traduções estão disponíveis globalmente
            if (typeof translations !== 'undefined' && translations.noMic) {
                return `
                    <p><strong>${translations.noMic}:</strong> ${translations.noMicDescription}</p>
                    <p><strong>${translations.mic}:</strong> ${translations.micDescription}</p>
                `;
            }
            
            // Fallback para português (site brasileiro)
            return `
                <p><strong>Sem Microfone:</strong> Ideal para palco, músicos, monitoramento e uso profissional de áudio.</p>
                <p><strong>Com Microfone:</strong> Ideal para uso casual, como jogos, reuniões e atividades do dia a dia. (Não recomendado para palco ou áudio profissional).</p>
            `;
        },
        
        _setupMutationObserver() {
            const productForm = document.querySelector(SELECTORS.productForm);
            if (!productForm) return;
            
            let debounceTimeout;
            const debouncedUpdate = () => {
                clearTimeout(debounceTimeout);
                debounceTimeout = setTimeout(() => {
                    this._addInfoButtons();
                }, 100);
            };
            
            const observer = new MutationObserver(mutations => {
                let shouldUpdate = false;
                
                for (const mutation of mutations) {
                    if (mutation.type === 'childList' || mutation.type === 'subtree') {
                        shouldUpdate = true;
                        break;
                    }
                }
                
                if (shouldUpdate) {
                    debouncedUpdate();
                }
            });
            
            observer.observe(productForm, {
                childList: true,
                subtree: true
            });
        }
    };
    
    // Inicialização
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
            MicrophoneInfo.init();
        });
    } else {
        MicrophoneInfo.init();
    }
    
}();